import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import LanguageSelect from "@/pages/LanguageSelect";
import Onboarding from "@/pages/Onboarding";
import Processing from "@/pages/Processing";
import Results from "@/pages/Results";
import Simulator from "@/pages/Simulator";
import Paywall from "@/pages/Paywall";
import Admin from "@/pages/Admin";
import MantraChat from "@/components/MantraChat";
import { Toaster } from "sonner";
import { LangProvider } from "@/lib/i18n";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/language" element={<LanguageSelect />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/processing" element={<Processing />} />
            <Route path="/results/:id" element={<Results />} />
            <Route path="/simulator" element={<Simulator />} />
            <Route path="/paywall" element={<Paywall />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <MantraChat />
          <Toaster theme="dark" position="top-center" />
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
